export default __webpack_public_path__ + "static/media/addadmin.5b7e2f42.svg";